import React from 'react'
import { useActivityFeed } from '@/hooks/useActivityFeed'
import { formatDistanceToNow } from 'date-fns'

export function ActivityFeed() {
  const { events, loading, error, refresh } = useActivityFeed()

  if (loading) {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-gray-300 border-t-transparent" />
      </div>
    )
  }

  if (error) {
    return (
      <div className="flex items-center gap-2 p-4 bg-red-50 text-red-800 rounded-lg">
        <span>Failed to load activity feed.</span>
        <button onClick={refresh} className="underline">Retry</button>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold">Recent Activity</h2>
        <button onClick={refresh} className="text-sm text-gray-600 hover:text-gray-900">Refresh</button>
      </div>
      <div className="space-y-3">
        {events.length === 0 ? (
          <p className="text-center py-8 text-gray-500">No recent activity</p>
        ) : (
          events.map((event) => (
            <ActivityEventCard key={event.id} event={event} />
          ))
        )}
      </div>
    </div>
  )
}

function ActivityEventCard({ event }: { event: any }) {
  const actionText: Record<string, string> = {
    added_display: 'added a new display',
    listed_sequence: 'listed a new sequence',
    followed_vendor: 'followed',
    updated_display: 'updated their display',
    purchased_sequence: 'purchased a sequence'
  }
  const text = actionText[event.action] || event.action
  return (
    <div className="flex items-start gap-3 p-4 bg-white rounded-lg border border-gray-200 hover:border-gray-300 transition-colors">
      <div className="flex-1">
        <p className="text-sm"><span className="font-medium">{event.actor_name}</span> {text}</p>
        {event.metadata?.display_name && (
          <p className="text-sm text-gray-600 mt-1">{event.metadata.display_name}</p>
        )}
        {event.metadata?.sequence_name && (
          <p className="text-sm text-gray-600 mt-1">{event.metadata.sequence_name}</p>
        )}
        <p className="text-xs text-gray-400 mt-2">{formatDistanceToNow(new Date(event.created_at), { addSuffix: true })}</p>
      </div>
    </div>
  )
}


